import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteGpt } from 'api/gpts';
import Button from 'components/Button';
import Popup from 'components/Popup';
import React from 'react';

export default function GptPopupRemove({
    visible,
    setVisible,
    gpt
}) {

    const cache = useQueryClient();

    const { mutate: remove, status } = useMutation({
        mutationKey: ['deleteGpt'],
        mutationFn: deleteGpt,
        onSuccess: () => {
            cache.invalidateQueries(['gpts']);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error removing gpt:", error);
        }
    });

    function onConfirmHandler() {
        return remove({
            id: gpt._id,
        });
    }

    if(!visible) return null;

    return (
        <Popup  
            visible={visible}
            setVisible={setVisible}
        >
            <div>
                <div className='flex'>
                    <p className=''>Sei sicuro di voler eliminare questo gpt? Questa azione non può essere annullata.</p>
                </div>

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='text-grey hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button onClick={onConfirmHandler} status={status}>Elimina</Button>
                </div>
            </div>
        </Popup>
    )
}
